import clsx from "clsx";
import { AutocompleteResult, SearchAutocompleteSection } from "../types";

interface ListItem {
  result: AutocompleteResult;
  section: SearchAutocompleteSection;
}

interface ListSectionProps {
  title: string;
  items: ListItem[];
  highlightedIndex: number;
  isMouseActive: boolean;
  onSelect: (item: ListItem) => void;
  highlightedRef: React.RefObject<HTMLButtonElement>;
  sectionIndex?: number;
  previousSectionsItemCount?: number;
}

export function ListSection({
  title,
  items,
  highlightedIndex,
  isMouseActive,
  onSelect,
  highlightedRef,
  previousSectionsItemCount = 0,
}: ListSectionProps) {
  return (
    <li>
      {title && <h3 className="mt-3 mb-1 ml-2 text-xs font-medium text-text-base-tertiary">{title}</h3>}
      {items.map(({ result, section }, index) => {
        const totalIndex = previousSectionsItemCount + index;
        const isHighlighted = totalIndex === highlightedIndex;
        return (
          <button
            data-testid="global-search__item"
            key={result.id}
            ref={isHighlighted ? highlightedRef : undefined}
            tabIndex={-1}
            className={clsx(
              "block rounded-md px-2 py-1.5 w-full whitespace-nowrap truncate text-left text-blue-grey-800 focus:bg-platform-blue-50 focus:outline-hidden",
              {
                "bg-platform-blue-50": isHighlighted && !isMouseActive,
                "hover:bg-platform-blue-50": isMouseActive,
              }
            )}
            onClick={() => onSelect({ result, section })}
          >
            {result.title}
          </button>
        );
      })}
    </li>
  );
}
